<template>
  <div
    class="card chart-card"
    style="height: 315px; border-radius: 8px; margin-bottom: 15px"
  >
    <!-- style="height: 283px" -->
    <div
      class="d-flex card-header portfolioPerformanceChartTitle"
      style="/*padding-left: 0px*/"
    >
      <h4 class="card-title dashboard-cards-header">DPI</h4>
      <div
        class="d-flex"
        style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
        v-tooltip.top-end="toolTipInfo"
      >
        <img src="static/img/graphInfo.svg" class />
      </div>
    </div>
    <!-- <chartjs-line-card :chartData="chartData" :chartOptions="chartOptions">
      <template slot="header">
        <div style="display: flex; justify-content: space-between;">
          <h4 class="card-title dashboard-cards-header">Portfolio Performance</h4>
        </div>
      </template>
    </chartjs-line-card>-->
    <div class="portfolioPerformanceChart">
      <chartjs-line
        :chartData="chartData"
        :chartOptions="chartOptions"
        :style="lineChartStyle"
      >
        <!--style="width:80%;display:block;margin-left:auto;margin-right:auto"-->
      </chartjs-line>
    </div>
  </div>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsLineCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
import ChartjsLine from "../../Chartjs/ChartjsLine";

export default {
  name: "line-dpi-chart-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsLineCard,
    ChartjsLine,
  },
  computed: {
    ...mapGetters("charts", ["dpiChartData"]),
    ...mapGetters("user", ["currency"]),
    chartData() {
      const self = this;
      let dpiData = [];
      self.dpiChartData.x.map((item, index) => {
        let obj = {};
        obj.x = item;
        obj.y = self.dpiChartData.y[index];
        dpiData.push(obj);
      });
      //   let dpiData = _.zipWith(
      //     self.dpiChartData.x,
      //     self.dpiChartData.y,
      //     function (x, y) {
      //       return { x, y };
      //     }
      //   );
      let data = {
        datasets: [
          {
            label: "DPI",
            data: dpiData,
            backgroundColor: "#009DE0",
            borderColor: "#009DE0",
            fill: false,
            pointRadius: self.dpiChartData.x.length < 2 ? 3 : 0,
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": " +
                `${
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ].y || 0
                } x`
              );
            },
          },
        },
        legend: {
          position: "bottom",
          align: "end",
          display: false,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            //usePointStyle: true
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return `${value} x`;
                },
              },
            },
          ],
          xAxes: [
            {
              display: true,
              type: "linear",
              position: "bottom",
              ticks: {
                callback: function (value, index, values) {
                  return value;
                },
                autoSkip: true,
                stepSize: 1,
                beginAtZero: false,
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      // right now just return the default (only) string
      return "The data shown here is collected from the data in the Summary Menu. Every time you enter new data it is time and date stamped and added to the DPI graph";
    },
    lineChartStyle() {
      return {
        position: "relative",
      };
    },
  },
  data() {
    return {};
  },
  props: {
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows the ROI of your portfolio over time.`;
      },
    },
  },
  mounted() {
    const self = this;
  },
};
</script>
<style >
</style>